export default __webpack_public_path__ + "media/flags/hu-a24910ba.svg";